import { Browser, OpenOptions } from '@capacitor/browser'
import { Typography, TypographyProps } from '@mui/material'
import { ElementType, FC, useCallback } from 'react'
import * as React from 'react'

/**
 *
 * @param link
 * @param options
 */
export const useBrowserLink = (
  link: string,
  options?: Omit<OpenOptions, 'url'>
): { onClick: () => void } => {
  const onClick = useCallback(async () => {
    await Browser.open({ url: link, ...options })
  }, [link, options])

  return { onClick }
}

export type BrowserLinkProps = {
  href: string
  component?: ElementType
} & TypographyProps

/**
 * Open external link inside app via Browser
 * @param href
 * @param children
 * @param props
 * @constructor
 */
export const BrowserLink: FC<BrowserLinkProps> = ({
  href,
  children,
  ...props
}) => {
  const { onClick } = useBrowserLink(href)
  return (
    <Typography
      {...props}
      onClick={onClick}
      sx={{ color: 'primary.main', cursor: 'pointer', ...props.sx }}
    >
      {children}
    </Typography>
  )
}
